export const autumnPointBack = {
  /** ページヘッダーのタイトル */
  title: "秋のポイントバックキャンペーン",
  hero: {
    period: "10/26(月) 12:00 〜 11/9(月) 12:00",
    /** 「\n」の位置で改行する（表示側は whitespace-pre-line） */
    subtitle: "対象の女の子と3分以上の\nビデオ通話をしてポイントをもらおう！",
    maxLabel: "最大",
    maxSuffix: "還元!!",
    pointUnit: "pt",
  },
  /** さがす画面の訴求カード */
  promo: {
    status: "開催中",
    /** 訴求の見出し（さがす画面のカード・好みに合う子のセクション） */
    /** 対象の女性のプロフィール画像の左下に付ける角丸四角形の印（小さな「この子と3分以上の / ビデオ通話で」 + 大きな「ポイントGET」） */
    targetBadge: {
      target: "この子と3分以上の\nビデオ通話で",
      main: "ポイントGET",
      /** 3分以上通話済みの子の印（グレーにした印の上に重ねる） */
      called: "通話済み",
    },
    /** 一覧ページのタイトル下に出す小さな補足 */
    listSubtitle: "ポイントバックキャンペーン対象",
    /** 「>」から開く一覧ページの題名（キャンペーン中。終わったら「あなたの好みに合う子」に戻る） */
    listTitle: "あなたにぴったりの女の子",
    /** 「\n」の位置で改行する（表示側は whitespace-pre-line） */
    headline: (args: { maxPoint: string }) =>
      `対象の女の子と3分以上のビデオ通話で\n最大${args.maxPoint}ptもらえる！`,
    lead: "好みの子とビデオ通話で",
    maxLabel: "最大",
    /** features/autumnPointBack/constants の MAX_TOTAL_POINT と揃える */
    maxPoint: "18,100",
    maxSuffix: "還元!!",
    cta: "好みの子を診断する",
    note: "30秒の診断であなた好みの子が表示されます",
  },
  /** 訴求バナー・進捗リングダイアログ */
  ticket: {
    getLabel: "GET",
    ariaLabel: "ポイントバックキャンペーン ビデオ通話ミッション 詳細を見る",
    progressAriaLabel: (args: {
      current: string | number;
      target: string | number;
    }) => `ポイント付与までの進捗 ${args.target}人中${args.current}人`,
  },
  /** さがす画面の一覧先頭のバナー */
  listBanner: {
    /** 「あと 1人 と通話で」の「あと」と「と通話で」 */
    remainHead: "あと",
    remainTail: "と通話で",
  },
  pickUp: {
    tag: "PICK UP",
    tagSub: "好みの女の子",
    /** ぼかしの奥に見せる仮のラベル（ユーザーは取得しない） */
    placeholderLabel: "好みの女の子",
    caption: "好みの女の子と通話・メッセージでポイントバック",
    lockMessage: "好みの子とビデオ通話して\nポイントをもらおう",
    lockCta: "好みの子を診断する",
  },
  summary: {
    earned: "獲得済み",
    max: "最大",
  },
  mission: {
    title: "ビデオ通話ミッション",
    badge: "段階制・全10段",
    description:
      "期間中に初めて3分以上ビデオ通話した「異なる女性」の人数で集計",
    countLabel: "3分以上ビデオ通話した女性",
    personUnit: "人",
    nextLabel: "次の達成まで",
    nextRemain: (args: { remain: string | number; reward: string | number }) =>
      `あと ${args.remain}人 で +${args.reward}pt`,
    allDone: "全ミッション達成!",
    rowLabel: (args: { target: string | number }) =>
      `${args.target}人と3分以上ビデオ通話する`,
    reward: (args: { point: string | number }) => `+${args.point}pt`,
    remain: (args: { count: string | number }) => `あと ${args.count}人`,
    /** 達成したミッションのスタンプ（ポイントは自動で付与される） */
    stamp: "達成",
    stampLabel: "達成",
    findUsers: "対象の女の子を探しに行く",
  },
  diagnoseCta: "好みの子を診断して通話する",
  /** ミッション達成のポイントを自動で受け取れたときのトースト */
  claimed: (args: { point: string | number }) =>
    `ミッション達成！ ${args.point}pt を獲得しました`,
  /** ビデオ通話の終了直後に出す、進捗が進んだことを伝えるアニメーション */
  callResult: {
    /** ポイントが付与されたとき */
    achievedTitle: "ミッション達成！",
    gainedLabel: "ポイントを獲得しました",
    /** 進捗だけ進んだとき */
    progressTitle: "ミッション達成まで",
    ringAriaLabel: (args: { goal: string | number; count: string | number }) =>
      `${args.goal}人中${args.count}人達成`,
    ringTotal: (args: { goal: string | number }) => `／ ${args.goal}人`,
  },
  survey: {
    submitFailed:
      "好みの保存に失敗しました。時間をおいてから再度お試しください",
  },
  notes: {
    title: "注意事項",
    items: [
      "ポイントバックは、各ミッション達成時に自動で付与されます。",
      "開催期間は 10/26(月) 12:00 〜 11/9(月) 12:00 です。",
      "人数は、期間中に初めて3分以上ビデオ通話した「異なる女性」の人数で集計します（同じ女性との再通話はカウントされません）。",
      "通話時間は1回の通話で3分以上が対象です。キャンペーン参加前の通話は対象外です。",
      "不正・規約違反と判断した場合は対象外となります。内容は予告なく変更・終了する場合があります。",
    ],
  },
} as const;
